import React from "react";
import { useTheme } from "styled-components";

const WIDTH = 100;
const HEIGHT = 30;
const PADDING = 3;

type DashboardTodaySparklineProps = {
  values: number[];
};

export const DashboardTodaySparkline: React.FC<
  DashboardTodaySparklineProps
> = ({ values }) => {
  const theme = useTheme();

  if (values.length < 2) {
    return null;
  }

  const max = Math.max(...values, 1);
  const points = values.map((value, index) => ({
    x: (index / (values.length - 1)) * WIDTH,
    y: HEIGHT - PADDING - (value / max) * (HEIGHT - PADDING * 2),
  }));
  const line = points.map(({ x, y }) => `${x},${y}`).join(" ");
  const last = points[points.length - 1];

  return (
    <svg
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      preserveAspectRatio="none"
      width="100%"
      height="30"
      aria-hidden
      style={{ display: "block", overflow: "visible" }}
    >
      <polygon
        points={`0,${HEIGHT} ${line} ${WIDTH},${HEIGHT}`}
        fill={theme.main}
        fillOpacity={0.12}
      />
      <polyline
        points={line}
        fill="none"
        stroke={theme.main}
        strokeWidth={1.6}
        vectorEffect="non-scaling-stroke"
      />
      <circle cx={last.x} cy={last.y} r={2.4} fill={theme.main} />
    </svg>
  );
};
